import { MasterDataEntityPage } from "../MasterDataEntityPage"
import { MasterDataPanelLayout } from "../MasterDataPanelLayout"
import { ArticleDetailPanel } from "../articles/ArticleDetailPanel"
import { ArticleListPanel } from "../articles/ArticleListPanel"
import { useRowMultiSelect } from "../useRowMultiSelect"

export function ArticlesPage() {
  const { selectedIds, toggleSelected, removeIds } = useRowMultiSelect()

  return (
    <MasterDataEntityPage
      titleKey="MC_MD_TAB_ARTICLES"
      helpArticleId="master-data.articles"
    >
      <MasterDataPanelLayout
        listPanel={
          <ArticleListPanel
            selectedIds={selectedIds}
            onToggleSelected={toggleSelected}
          />
        }
        detailPanel={
          <ArticleDetailPanel
            selectedIds={selectedIds}
            onRemoveIds={removeIds}
          />
        }
      />
    </MasterDataEntityPage>
  )
}
